// features.ts — session 7 3.13: which features this user may use (contracts FEATURES; beta = operators only).
import { useQuery } from "@tanstack/react-query";
import { apiGet } from "./client.ts";

export const featuresApi = { list: () => apiGet<{ features: Record<string, boolean> }>("/features") };
/** True only when the backend says this user may use the feature (unknown / loading → false: never shown by default). */
export function useFeature(id: string): boolean {
  const q = useQuery({ queryKey: ["features"], queryFn: () => featuresApi.list(), staleTime: 5 * 60_000 });
  return q.data?.features?.[id] === true;
}
